module.exports = __webpack_public_path__ + "static/media/Notice of Proposal to Refuse to Renew Yarco Developments - January 2022.4ba5e984.pdf";